var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.offer && _vm.offer.Id
    ? _c("div", { staticClass: "dialogSpecialOfferInfo" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "heading" },
            [
              _c("special-translator", {
                attrs: { offer: _vm.offer, phrId: "offer.title" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "img-holder" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "so-info-msg" },
            [
              _c("special-translator", {
                attrs: { offer: _vm.offer, phrId: "modal.info" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "heading-small" }, [
            _vm._v(_vm._s(_vm.offer.Name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "so-description" }, [
            _vm._v(_vm._s(_vm.offer.Description))
          ]),
          _vm._v(" "),
          _vm.minStake || _vm.maxStake
            ? _c("div", { staticClass: "offer-requirements" }, [
                _c("br"),
                _vm._v(
                  _vm._s(_vm.$t("SpecialOffer.modal.requirements")) +
                    ":\n        "
                ),
                _vm.minStake
                  ? _c("div", { staticClass: "min-stake" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SpecialOffer.modal.requirements.minStake")
                        ) +
                          ": " +
                          _vm._s(_vm._f("currency")(_vm.minStake))
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.maxStake
                  ? _c("div", { staticClass: "max-stake" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SpecialOffer.modal.requirements.maxStake")
                        ) +
                          ": " +
                          _vm._s(_vm._f("currency")(_vm.maxStake))
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                return _vm.deactivateDialog()
              }
            }
          },
          [
            _c("special-translator", {
              attrs: { offer: _vm.offer, phrId: "modal.btn.OK" }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5401d74a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5401d74a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/SpecialOffers/specialOfferInfoDialog.vue
// module id = null
// module chunks = 